import { jsx as _jsx } from "react/jsx-runtime";
import { alpha } from "@mui/material/styles";
import { ElementChip } from "./base/ElementChip";
import { ValueIcon } from "./valueIcons/ValueIcon";
import { ALLERGY_FALLBACK_ICON, ALLERGY_ICONS, findValueIcon } from "./valueIcons/valueIconMaps";
var COLOR = "#F25C05";
var ICON_SX = { fontSize: 18, color: COLOR };
/** The value's own icon, else the allergy icon. */
export function AllergyIcon(_a) {
    var _b;
    var value = _a.value;
    var spec = (_b = findValueIcon(ALLERGY_ICONS, value)) !== null && _b !== void 0 ? _b : ALLERGY_FALLBACK_ICON;
    return _jsx(ValueIcon, { glyph: spec.glyph, off: spec.off, sx: ICON_SX });
}
export function AllergyElement(_a) {
    var label = _a.label, value = _a.value, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, onDelete = _a.onDelete;
    if (!label)
        return null;
    return (_jsx(ElementChip, { text: label, startIcon: _jsx(AllergyIcon, { value: value }), borderColor: alpha(COLOR, 0.28), active: active, onClick: onClick, onDelete: onDelete }));
}
